<template>
  <div class="page" v-loading="loading">
    <div class="text_right">
      <!-- <el-button color="#FF7739">导入记录</el-button> -->
      <!-- <el-button color="#FF7739">删除记录</el-button> -->
    </div>

    <el-button
      color="#FF7739"
      plain
      style="color: #ff7739"
      @click="create"
      class="hover_btn"
      >录入学员</el-button
    >
    <el-button
      color="#FF7739"
      plain
      style="color: #ff7739"
      @click="importShow = true"
      class="hover_btn"
      >导入学员</el-button
    >
    <el-button
      color="#FF7739"
      plain
      style="color: #ff7739"
      @click="exportUser"
      class="hover_btn"
      >导出学员</el-button
    >
    <el-input
      v-model="search.search"
      style="width: 210px; margin-left: 20px"
      placeholder="请输入学员名称/手机号/网班号"
    />
    <el-select
      v-model="search.sys_class_id"
      placeholder="请选择班级"
      style="margin: 0 10px"
    >
      <el-option
        v-for="item in classOptions"
        :key="item.sys_class_id"
        :label="item.sys_class_name"
        :value="item.sys_class_id"
      />
    </el-select>
    <el-button color="#FF7739" @click="onSearch">搜索</el-button>

    <br />
    <br />

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        'text-align': 'center',
        background: '#FFF7EB',
        color: '#FF7739',
      }"
    >
      <el-table-column prop="mem_id" label="学员ID" align="center" />
      <el-table-column prop="mem_name" label="姓名" align="center" />
      <el-table-column prop="mem_phone" label="手机号" align="center" />
      <el-table-column prop="mem_idcard" label="身份证号" align="center" />
      <el-table-column prop="mem_regdate" label="创建时间" align="center" />
      <el-table-column prop="jobs_submit_count" label="已提交" align="center" />
      <el-table-column prop="jobs_wait_count" label="待提交" align="center" />
      <el-table-column prop="status" label="操作" align="center">
        <template #default="scope">
          <el-button
            color="#FF7739"
            icon="Edit"
            circle
            @click="edit(scope.row)"
          />
          <el-button
            color="#FF7739"
            icon="Delete"
            circle
            @click="del(scope.row)"
          />
          <el-button
            color="#FF7739"
            icon="RefreshRight"
            circle
            @click="reset(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>

    <Pagination @pageChange="pageChangeFn" :total="total"></Pagination>
    <el-dialog v-model="dialogShow" title="录入学员" width="30%">
      <el-form ref="formRef" :model="form" label-width="130px">
        <el-form-item
          label="姓名"
          prop="mem_name"
          :rules="[
            {
              required: true,
              message: '请输入姓名',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="form.mem_name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item
          label="手机号"
          prop="mem_phone"
          :rules="[
            {
              required: true,
              message: '请输入手机号',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="form.mem_phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item
          label="用户名"
          prop="mem_nbnumber"
          :rules="[
            {
              required: true,
              message: '请输入用户名',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="form.mem_nbnumber" placeholder="网班号" />
        </el-form-item>

        <el-form-item
          label="班级"
          prop="sys_class_id"
          :rules="[
            {
              required: true,
              message: '请选择班级',
              trigger: 'blur',
            },
          ]"
        >
          <el-select v-model="form.sys_class_id" placeholder="请选择班级">
            <el-option
              v-for="item in classOptions"
              :key="item.sys_class_id"
              :label="item.sys_class_name"
              :value="item.sys_class_id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            color="#FF7739"
            @click="onSubmit(formRef)"
            :loading="btn_loading"
          >
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog v-model="editShow" title="编辑用户" width="30%">
      <el-form ref="e_formRef" :model="e_form" label-width="130px">
        <el-form-item label="用户名" prop="mem_nbnumber">
          <el-input
            v-model="e_form.mem_nbnumber"
            placeholder="请输入用户名"
            disabled
          />
        </el-form-item>
        <el-form-item
          label="姓名"
          prop="mem_name"
          :rules="[
            {
              required: true,
              message: '请输入姓名',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="e_form.mem_name" placeholder="请输入姓名" />
        </el-form-item>

        <el-form-item label="身份证" prop="mem_idcard">
          <el-input v-model="e_form.mem_idcard" placeholder="请输入身份证" />
        </el-form-item>
        <el-form-item label="性别" prop="mem_gender">
          <el-radio-group v-model="e_form.mem_gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="班级" prop="sys_class_id">
          <el-select v-model="e_form.sys_class_id" placeholder="请选择班级">
            <el-option
              v-for="item in classOptions"
              :key="item.sys_class_id"
              :label="item.sys_class_name"
              :value="item.sys_class_id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            color="#FF7739"
            @click="update(e_formRef)"
            :loading="btn_loading"
          >
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog v-model="importShow" title="导入学员" width="30%">
      <div class="text_center">
        <a
          style="color: #ff7739"
          href="http://sev.netban.cn/public/attachment/college_user_import.xls"
          >下载导入模板文件</a
        ><br /><br />
        <el-upload
          v-model="fileList"
          class="upload-demo"
          :action="action"
          :headers="headers"
          :on-success="onSuccess"
          :limit="3"
          :on-exceed="handleExceed"
        >
          <el-button color="#FF7739">
            点击上传<el-icon class="el-icon--right"><Upload /></el-icon>
          </el-button>
        </el-upload>
        <br />
        <br />
        <el-select v-model="upload.sys_class_id" placeholder="请选择班级">
          <el-option
            v-for="item in classOptions"
            :key="item.sys_class_id"
            :label="item.sys_class_name"
            :value="item.sys_class_id"
          />
        </el-select>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            color="#FF7739"
            :loading="btn_loading"
            @click="confirmImport"
          >
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { reactive, ref, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Pagination from '../../components/Pagination'
import {
  getList,
  handleAdd,
  handleDel,
  getDepartment,
  resetPass,
  handleEdit,
  importUser,
} from '../../request/userList'

export default {
  components: { Pagination },
  setup() {
    const formRef = ref()
    const e_formRef = ref()
    const router = useRouter()
    const state = reactive({
      loading: false,
      dialogShow: false,
      importShow: false,
      editShow: false,
      tableData: [],
      classOptions: [],
      total: 0,
      form: {},
      e_form: {},
      search: { page: 1 },
      fileList: [],
      action: process.env.VUE_APP_URL + '/m/upload',
      headers: {},
      upload: {},
    })
    onMounted(() => {
      state.headers.token = localStorage.getItem('school_token')
      state.headers.numbers = JSON.parse(localStorage.getItem('school')).sid
      init()
      getClass()
    })

    const init = async () => {
      state.loading = true
      const { data, code, msg, total } = await getList(state.search)
      state.loading = false
      if (code == 200) {
        state.tableData = data
        state.total = total
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const getClass = async () => {
      const { data, code, msg, total } = await getDepartment(state.search)
      if (code == 200) {
        state.classOptions = data
      } else {
        ElMessage.error(msg)
        return
      }
    }

    const onSearch = () => {
      state.search.page = 1
      init()
    }

    const pageChangeFn = value => {
      state.search.page = value
      init()
    }
    const create = () => {
      state.dialogShow = true
      state.form = {}
    }
    const onSubmit = async (a, b) => {
      if (!formRef) return
      formRef.value.validate(valid => {
        if (valid) {
          state.btn_loading = true
          confirm()
        }
      })
    }
    const update = async (a, b) => {
      if (!e_formRef) return
      e_formRef.value.validate(valid => {
        if (valid) {
          state.btn_loading = true
          confirmUpdate()
        }
      })
    }
    const confirmUpdate = async () => {
      state.btn_loading = true
      const { data, code, msg } = await handleEdit(state.e_form)
      state.btn_loading = false
      if (code == 200) {
        ElMessage.success(msg)
        state.editShow = false
        init()
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const confirm = async () => {
      const { data, code, msg } = await handleAdd(state.form)
      state.btn_loading = false
      if (code == 200) {
        ElMessage.success(msg)
        state.dialogShow = false
        init()
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const del = row => {
      ElMessageBox({
        title: '提示',
        message: `确认要删除吗？`,
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            confirmDel(row.mem_id, instance, done)
          } else {
            done()
          }
        },
      })
    }
    const reset = row => {
      ElMessageBox({
        title: '提示',
        message: `确认要重置密码吗？`,
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            confirmReset(row.mem_id, instance, done)
          } else {
            done()
          }
        },
      })
    }
    const confirmDel = async (mem_id, instance, done) => {
      const { data, code, msg } = await handleDel({
        mem_id: mem_id,
      })
      instance.confirmButtonLoading = false
      if (code == 200) {
        ElMessage.success(msg)
        done()
        init()
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const confirmReset = async (mem_id, instance, done) => {
      const { data, code, msg } = await resetPass({
        id: mem_id,
      })
      instance.confirmButtonLoading = false
      if (code == 200) {
        ElMessage.success(msg)
        done()
        init()
      } else {
        ElMessage.error(msg)
        return
      }
    }

    const edit = row => {
      state.editShow = true
      state.e_form = Object.assign({}, row)
    }

    const onSuccess = res => {
      console.log(res)
      if (res.code == 200) {
        state.upload.importPath = res.data
        ElMessage.success(res.msg)
      } else {
        ElMessage.error(res.msg)
      }
    }
    const confirmImport = async () => {
      state.btn_loading = true
      const { data, code, msg } = await importUser(state.upload)
      state.btn_loading = false
      if (code == 200) {
        state.importShow = false
        ElMessage.success(msg)
        init()
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const exportUser = async () => {
      state.loading = true
      const pageSize = 20
      const tpage = Math.ceil(state.total / pageSize)
      var FileSaver = require('file-saver')
      var title =
        '\uFEFF' + '网班ID,姓名,手机号,身份证号,注册时间,已提交,待提交,班级\n'
      var con = ''
      var txt = document.querySelector('.el-loading-text')
      var count = 0
      for (var i = 1; i <= tpage; i++) {
        const { data, code, msg, total } = await getList({
          page: i,
          pageSize: pageSize,
          search: state.search.search,
        })
        if (code == 200) {
          data.forEach(e => {
            e.sys_class_name = '无'
            if (e.relation_class) {
              e.sys_class_name = e.relation_class.sys_class_name
            }
            con +=
              +e.mem_id +
              ',' +
              e.mem_name +
              ',' +
              e.mem_phone +
              ',' +
              "'" +
              e.mem_idcard +
              ',' +
              e.mem_regdate +
              ',' +
              e.jobs_submit_count +
              ',' +
              e.jobs_wait_count +
              ',' +
              e.sys_class_name +
              '\n'
          })
          count = (i - 1) * pageSize + data.length
        }
        console.log(con)
        // txt.innerHTML = '已经导出' + count + '/' + state.total + '条记录'
      }
      var blob = new Blob([title + con], {
        type: 'application/vnd.ms-excel',
      })
      state.loading = false
      FileSaver.saveAs(blob, 'user.csv')
    }

    return {
      ...toRefs(state),
      formRef,
      e_formRef,
      init,
      onSearch,
      onSubmit,
      create,
      pageChangeFn,
      del,
      confirmDel,
      getClass,
      reset,
      confirmReset,
      edit,
      update,
      confirmUpdate,
      onSuccess,
      confirmImport,
      exportUser,
    }
  },
}
</script>

<style lang="less" scoped>
.el-button {
  color: #fff;
}
.hover_btn {
  background: #fff1eb;
}
.hover_btn:hover {
  background: #fff1eb;
}
</style>
